import { cn } from "@lib/utils/helpers";
import styles from "../../styles/applicationDetail.module.css";
import editStyles from "../../styles/editForm.module.css";
import type { CreditReportCoreLogicSectionProps } from "../../types";

export function CreditReportCoreLogicSection({ tab }: CreditReportCoreLogicSectionProps) {
  const {
    applicationData,
    canInputScore,
    customScore,
    handleSaveScore,
    savingScore,
    setCustomScore,
    showCoreLogicSection,
    showCoreLogicSectionTitle,
    showCoreLogicApplicantScore,
  } = tab;

  if (!showCoreLogicSection) return null;

  return (
    <div
      className={styles.section}
      data-testid="application-credit-report-tab-section-core-logic"
    >
      {showCoreLogicSectionTitle ? (
        <h2
          className={styles.sectionTitle}
          data-testid="application-credit-report-tab-core-logic-title"
        >
          Core-Logic
        </h2>
      ) : null}

      {showCoreLogicApplicantScore ? (
        <div
          className={styles.infoRow}
          data-testid="application-credit-report-tab-applicant-score-row"
        >
          <div className={styles.infoColumn}>
            <h6
              style={{ fontSize: "18px", fontWeight: "600" }}
              data-testid="application-credit-report-tab-applicant-score-value"
            >
              Applicant Score :{" "}
              {applicationData?.corelogic_applicant_score &&
              applicationData.corelogic_applicant_score !== "0"
                ? applicationData.corelogic_applicant_score
                : "No Score Available"}
            </h6>
          </div>
        </div>
      ) : null}

      {canInputScore &&
        showCoreLogicApplicantScore &&
        (!applicationData?.corelogic_applicant_score ||
          applicationData?.corelogic_applicant_score === "0") && (
          <div className={editStyles.formRow} style={{ marginTop: "16px" }}>
            <div className={editStyles.formGroup}>
              <label className={editStyles.label} data-testid="application-credit-report-tab-custom-score-label">
                Enter score from SafeRent report
              </label>
              <input
                data-testid="application-credit-report-tab-custom-score-input"
                type="number"
                className={cn(editStyles.input, "w-full max-w-[200px]")}
                value={customScore}
                onChange={(e) => setCustomScore(e.target.value)}
                placeholder="Enter score"
              />
            </div>
            <div
              className={editStyles.formGroup}
              style={{ marginTop: "24px" }}
            >
              <button
                type="button"
                className={styles.btnSmall}
                data-testid="application-credit-report-tab-save-score-button"
                onClick={handleSaveScore}
                disabled={savingScore || !customScore}
              >
                {savingScore ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        )}
    </div>
  );
}
